export default {
  inject: ['load'],
  data() {
    return {
      allGeneralActions: [],
    };
  },
  methods: {
    getAllGeneralActions: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllGeneralActions').then(() => {
        if (this.$store.state.generalActionModule.successFlag) {
          this.allGeneralActions = this.$store.state.generalActionModule.allGeneralActions;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.generalActionModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getAllGeneralActions();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.generalActionModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getAllGeneralActions();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.generalActionModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
